import { render } from "./SpecializationSection.vue?vue&type=template&id=48e01dff&scoped=true"
import script from "./SpecializationSection.vue?vue&type=script&lang=js"
export * from "./SpecializationSection.vue?vue&type=script&lang=js"

import "./SpecializationSection.vue?vue&type=style&index=0&id=48e01dff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e01dff"]])

export default __exports__